import React, { useState,useEffect } from "react";
import axios from "axios";
import config from "../utils/config";
import { useNavigate } from "react-router-dom";
export default function Contact() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
useEffect(() => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "instant",
  });
}, []);
  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      const res = await axios.post(
        `${config.baseurl}/save-contact-message/`,
        formData
      );

      if (res.data.status === "success") {

        alert("Message Sent Successfully");

        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });

      }

    } catch (error) {

      console.log(error);

    }

  };

  return (
  <div className="relative min-h-screen text-white">

    <video
      autoPlay
      muted
      loop
      playsInline
      className="fixed top-0 left-0 w-full h-full object-cover -z-20"
    >
      <source src="/videos/bg.mp4" type="video/mp4" />
    </video>
    <div className="fixed inset-0 bg-black/20 -z-10"></div>

    <div className="relative z-10 py-3">
<h1 className="text-center p-6 font-bold text-5xl text-cyan-500">Contact Us</h1>
      <div className="max-w-5xl mx-auto px-5">

    <form onSubmit={handleSubmit}
  className="bg-black/50 backdrop-blur-sm p-8 rounded-xl border border-white/20"
>
  <div className="grid md:grid-cols-2 gap-5">

    <div>
      <label className="block mb-2 text-cyan-400 font-semibold">
        Name
      </label>
      <input
        type="text"
        name="name"
        placeholder="Enter Your Name"
        value={formData.name}
        onChange={handleChange}
        className="w-full border border-gray-400 bg-transparent p-4 rounded-lg"
        required
      />
    </div>

    <div>
      <label className="block mb-2 text-cyan-400 font-semibold">
        Email Address
      </label>
      <input
        type="email"
        name="email"
        placeholder="Enter Your Email"
        value={formData.email}
        onChange={handleChange}
        className="w-full border border-gray-400 bg-transparent p-4 rounded-lg"
        required
      />
    </div>

  </div>

  <div className="mt-5">
    <label className="block mb-2 text-cyan-400 font-semibold">
      Subject
    </label>
    <input
      type="text"
      name="subject"
      placeholder="Enter Subject"
      value={formData.subject}
      onChange={handleChange}
      className="w-full border border-gray-400 bg-transparent p-4 rounded-lg"
      required
    />
  </div>

  <div className="mt-5">
    <label className="block mb-2 text-cyan-400 font-semibold">
      Message
    </label>
    <textarea
      rows="6"
      name="message"
      placeholder="Enter Your Message"
      value={formData.message}
      onChange={handleChange}
      className="w-full border border-gray-400 bg-transparent p-4 rounded-lg"
      required
    />
  </div>

  <div className="text-center mt-5">
    <button
      type="submit"
      className="bg-cyan-500 hover:bg-cyan-600 px-8 py-3 rounded-lg"
    >
      Send Message
    </button>
  </div>

</form>

      </div>

      <div className="max-w-7xl mx-auto px-5 py-16">

        <div className="grid md:grid-cols-2 gap-8">

          <iframe
            title="Kannur"
            src="https://maps.google.com/maps?q=Kannur&t=&z=13&ie=UTF8&iwloc=&output=embed"
            className="w-full h-[350px] rounded-xl"
          />

          <iframe
            title="Chennai"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d248756.13131228788!2d80.04385969043571!3d13.04747331623444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265ea4f7d3361%3A0x6e61a70b6863d433!2sChennai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1781085221630!5m2!1sen!2sin"
            className="w-full h-[350px] rounded-xl"
          />

        </div>

      </div>

   
    </div>
   <div className="bg-black/70 backdrop-blur-md py-12">

        <div className="max-w-7xl mx-auto px-5">

          <div className="grid md:grid-cols-3 gap-10">

            <div>

              <h3 className="text-xl font-bold text-cyan-400 mb-3">
                Kerala Branch
              </h3>

              <p className="leading-7">
                1st Floor - JK Building
                <br />
                Kannur, Kannur 670684
                <br />
                Phone: +91 90000 90000
              </p>

              <h3 className="text-xl font-bold text-cyan-400 mt-6 mb-3">
                Tamil Nadu Branch
              </h3>

              <p className="leading-7">
                First Floor, D Block,
                <br />
                JK Park, chennai,
                <br />
                Chennai, Tamil Nadu 600100
                <br />
                Phone: +91 70000 80000
                <br />
                Email: jk@gmail.com
              </p>

            </div>

            <div>

              <h3 className="text-xl font-bold text-cyan-400 mb-5">
                Quick Links
              </h3>

              <ul className="space-y-3">

                <li  className="cursor-pointer" onClick={() => navigate("/home")}>Home</li>
                <li  className="cursor-pointer" onClick={() => navigate("/about")}>About Us</li>
                <li className="cursor-pointer"  onClick={() => navigate("/services")}>Services</li>
                <li  className="cursor-pointer" onClick={() => navigate("/product")}>Products</li>
             

              </ul>

            </div>

            <div>

              <h3 className="text-xl font-bold text-cyan-400 mb-5">
                More Links
              </h3>

              <ul className="space-y-3">

                <li  className="cursor-pointer" onClick={() => navigate("/careers")}>Career</li>
                <li className="cursor-pointer"  onClick={() => navigate("/events")}>Events</li>
                <li  className="cursor-pointer" onClick={() => navigate("/blogs")}>Blogs</li>

              </ul>

            </div>

          </div>

        </div>

      </div>

  </div>
);
}